module.exports = __webpack_public_path__ + "static/media/r6.a914bc15.jfif";